import { render, staticRenderFns } from "./IntegrationProviderField.vue?vue&type=template&id=68e076ae&lang=pug&"
import script from "./IntegrationProviderField.vue?vue&type=script&lang=js&"
export * from "./IntegrationProviderField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports